import { StatementService } from '../../../service/StatementService'
import TYPES from '../../../config/Types'
import { DependencyContainer } from '../../../config/DependencyContainer'

const statementService = DependencyContainer.getContainer().get<StatementService>(TYPES.StatementService)

const statementUtils = {
    get statementService () { return statementService },
}

export default statementUtils
